<ion-menu contentId="content">
  <ion-header>
    <ion-toolbar>
      <ion-title class="ion-text-wrap ion-no-padding">
        <div class="user-info">
          <ion-icon name="person"></ion-icon>
          <span>{{ userSrv.user?.USERNAME ?? userSrv.user?.EMAIL ?? '' }}</span>
        </div>
      </ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <ion-list mode="ios">
      @if (userSrv.isAdmin()) {
        <ion-list-header mode="ios">Active endpoint:</ion-list-header>
        <ion-item (click)="changeActiveEndpoint($event)">
          @if (activeEndpoint(); as activeEndpoint) {
            <ion-label class="ion-text-wrap">{{ activeEndpoint.name }}: {{ activeEndpoint.description }}</ion-label>
            <ion-icon name="checkmark-circle" slot="end" size="small"></ion-icon>
          }
        </ion-item>
      }

      <ion-item (click)="settingPage()" class="ion-margin-vertical">
        <ion-icon name="settings" slot="start" size="small"></ion-icon>
        <ion-label>Einstellungen</ion-label>
      </ion-item>

      @if (userSrv.isPartner()) {
        <ion-item (click)="labelsPage()" class="ion-margin-vertical">
          <ion-icon name="pricetags-outline" slot="start" size="small"></ion-icon>
          <ion-label>Verträge</ion-label>
        </ion-item>
      }

      @if (userSrv.isAdmin()) {
        <ion-item (click)="conferencePage()" class="ion-margin-vertical">
          <ion-icon name="logo-whatsapp" slot="start" size="small"></ion-icon>
          <ion-label>Conferences</ion-label>
        </ion-item>

        <ion-item (click)="pinManagementPage()" class="ion-margin-vertical">
          <ion-icon name="apps" slot="start" size="small"></ion-icon>
          <ion-label>PIN Management</ion-label>
        </ion-item>

        <ion-item (click)="blackListTab()" class="ion-margin-vertical">
          <ion-icon name="ban" slot="start" size="small"></ion-icon>
          <ion-label>Blacklist</ion-label>
        </ion-item>

        <ion-item (click)="blockListTab()" class="ion-margin-vertical">
          <ion-icon name="lock-closed" slot="start" size="small"></ion-icon>
          <ion-label>Blocklist</ion-label>
        </ion-item>

        @if (isDesktop) {
          <ion-item (click)="exportAddresses($event)" class="ion-margin-vertical">
            <ion-icon name="download-outline" slot="start" size="small"></ion-icon>
            <ion-label>Export addresses</ion-label>
          </ion-item>

          <ion-item (click)="verifyAddresses()" class="ion-margin-vertical">
            <ion-icon src="assets/icons/home-address.svg" slot="start" size="small"></ion-icon>
            <ion-label>Verify addresses</ion-label>
          </ion-item>

          <ion-item id="popover-btn" [button]="true" class="ion-margin-vertical">
            <ion-icon src="assets/icons/address-maintenance.svg" slot="start" size="small"></ion-icon>
            <ion-label>Address maintenance</ion-label>
          </ion-item>
          <!-- Hidden file input for importing Swiss addresses -->
          <input #fileInput type="file" class="ion-hide" accept=".xlsx" (change)="importSwissAddresses($event)">
          <ion-popover trigger="popover-btn" side="right" alignment="end" mode="md" [dismissOnSelect]="true">
            <ng-template>
              <ion-content>
                <ion-list>
                  <ion-item [button]="true" [detail]="false" (click)="exportSwissAddresses()">
                    <ion-label>Export for Swiss Post</ion-label>
                    <ion-icon src="assets/icons/export-addresses.svg" slot="end" size="small"></ion-icon>
                  </ion-item>
                  <ion-item lines="none" [button]="true" [detail]="false" (click)="fileInput.click()">
                    <ion-label>Import for Swiss Post</ion-label>
                    <ion-icon src="assets/icons/import-addresses.svg" slot="end" size="small"></ion-icon>
                  </ion-item>
                </ion-list>
              </ion-content>
            </ng-template>
          </ion-popover>
        }
      }

      <ion-item (click)="logout()" class="ion-margin-vertical">
        <ion-icon name="log-out" slot="start" size="small"></ion-icon>
        <ion-label>Abmelden</ion-label>
      </ion-item>
    </ion-list>
  </ion-content>
</ion-menu>




